import { useEffect, useState } from 'react';
import { createPassword } from '@/services/user';
import { getFieldErrorMessages, parseResponseError } from '@/utils/api';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { useNotify } from '@/components/snackbar';
import { CreatePasswordSchema } from '../../validation';

export function useCreatePasswordForm({ handleClose }) {
  const notify = useNotify();
  const [passwordServerErrors, setPasswordServerErrors] = useState([]);

  const defaultValues = {
    password: '',
    confirmPassword: '',
  };

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(CreatePasswordSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    watch,
    formState: { isSubmitting, errors },
  } = methods;

  const password = (watch('password') ?? '').trim();

  useEffect(() => {
    setPasswordServerErrors([]);
  }, [password]);

  const { mutate, isLoading: isLoadingCreatePassword } = useMutation({
    mutationFn: (value) => createPassword({ password: value }),
    onSuccess: () => {
      notify.success('Senha criada com sucesso.');
      handleClose(false);
    },
    onError: (error) => {
      const messages = getFieldErrorMessages(error, 'password');

      if (messages.length && error.fieldErrors.length === 1) {
        setPasswordServerErrors(messages);
        return;
      }

      notify.error(parseResponseError(error));
    },
  });

  const onSubmit = (data) => {
    setPasswordServerErrors([]);
    mutate(data.password);
  };

  return {
    methods,
    isSubmitting,
    isLoadingCreatePassword,
    onSubmit: handleSubmit(onSubmit),
    password,
    passwordServerErrors,
    passwordHasError: Boolean(errors?.password),
  };
}
